import React, { useState } from 'react';
import './NewCase.css';

const NewCase = ({ onBack, token }) => {
  const [formData, setFormData] = useState({
    case_number: '',
    case_title: '',
    Opponent_name: '',
    party_b: '',
    case_type: '',
    description: '',
    case_location: '',
    institution_date: '',
    task_to_be_done: '',
    court_name: '',
    judge_name: '',
    client_name: '',
    client_phone: '',
    client_payment_amount: '',
    client_reference_of: '',
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const caseTypes = [
    'Civil Case',
    'Criminal Case',
    'Banking Case',
    'Family Case',
    'Intellectual Property Case',
    'Commercial Case',
    
  ];

  const representations = [
    'Petitioner/Plaintiff',
    'Respondent/Defendant',
  
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate required fields
    if (!formData.case_type || !formData.client_name) {
      setError('Please fill in all required fields');
      return;
    }

    try {
      setLoading(true);
      setError('');
      setSuccess('');

      const apiUrl = `${process.env.REACT_APP_API_URL}/api/lawyer/add/case`;
      console.log('Submitting case to:', apiUrl);
      
      // Map Opponent_name to party_a for API
      const dataToSend = {
        ...formData,
        party_a: formData.Opponent_name,
      };
      delete dataToSend.Opponent_name;
      
      console.log('Form data:', dataToSend);

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          ...(token && { 'Authorization': `Bearer ${token}` }),
        },
        body: JSON.stringify(dataToSend),
      });

      console.log('API Response status:', response.status);

      const data = await response.json();
      console.log('API Response:', data);

      if (response.ok) {
        setSuccess('Case added successfully!');
        
        // Reset form
        setFormData({
          case_number: '',
          case_title: '',
          Opponent_name: '',
          party_b: '',
          case_type: '',
          description: '',
          case_location: '',
          institution_date: '',
          task_to_be_done: '',
          court_name: '',
          judge_name: '',
          client_name: '',
          client_phone: '',
          client_payment_amount: '',
          client_reference_of: '',
        });

        // Go back after 1.5 seconds
        setTimeout(() => {
          onBack();
        }, 1500);
      } else {
        setError(data.message || 'Failed to add case');
      }
    } catch (err) {
      console.error('Error adding case:', err);
      setError(err.message || 'Failed to add case');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="new-case-container">
      {/* Header */}
      <div className="case-form-header">
        <button className="back-button" onClick={onBack}>
          ←
        </button>
        <h2>New Case</h2>
      </div>

      {/* Status Messages */}
      {error && <div className="error-message">{error}</div>}
      {success && <div className="success-message">{success}</div>}

      {/* Form */}
      <form onSubmit={handleSubmit} className="new-case-form">
        {/* Case Details Section */}
        <div className="form-section">
          <h3>Case Details</h3>

          <div className="form-group">
            <label>Case Number</label>
            <input
              type="text"
              name="case_number"
              value={formData.case_number}
              onChange={handleInputChange}
              placeholder="Enter case number (optional)"
            />
          </div>


          <div className="form-group">
            <label>Petitioner/Plaintiff *</label>
            <input
              type="text"
              name="Opponent_name"
              value={formData.Opponent_name}
              onChange={handleInputChange}
              placeholder="Enter petitioner/plaintiff name"
               required
            />
          </div>

          <div className="form-group">
            <label>Respondent/Defendant *</label>
            <input
              type="text"
              name="party_b"
              value={formData.party_b}
              onChange={handleInputChange}
              placeholder="Enter respondent/defendant name"
              required
            />
          </div>


          <div className="form-group">
            <label>Case Type *</label>
            <select
              name="case_type"
              value={formData.case_type}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Case Type</option>
              {caseTypes.map(type => (
                <option key={type} value={type}>{type}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Representation</label>
            <select
              name="client_reference_of"
              value={formData.client_reference_of}
              onChange={handleInputChange}
            >
              <option value="">Select Representation</option>
              {representations.map(rep => (
                <option key={rep} value={rep}>{rep}</option>
              ))}
            </select>
          </div>

          <div className="form-group full-width">
            <label>Description</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              placeholder="Enter case description"
              rows="4"
            />
          </div>

          <div className="form-group">
            <label>Case Location *</label>
            <div className="location-input-wrapper">
              <input
                type="text"
                name="case_location"
                value={formData.case_location}
                onChange={handleInputChange}
                placeholder="Enter case location"
                 required
              />
              <span className="location-icon">📍</span>
            </div>
          </div>

          <div className="form-group">
            <label>Case Initial Date *</label>
            <div className="date-input-wrapper">
              <input
                type="date"
                name="institution_date"
                value={formData.institution_date}
                onChange={handleInputChange}
                 required
              />
              <span className="date-icon">📅</span>
            </div>
          </div>

          <div className="form-group full-width">
            <label>Task to be done</label>
            <textarea
              name="task_to_be_done"
              value={formData.task_to_be_done}
              onChange={handleInputChange}
              placeholder="Enter tasks to be done"
              rows="3"
            />
          </div>
        </div>

        {/* Court & Judge Section */}
        <div className="form-section">
          <div className="form-group">
            <label>Court Name *</label>
            <input
              type="text"
              name="court_name"
              value={formData.court_name}
              onChange={handleInputChange}
              placeholder="Enter court name"
               required
            />
          </div>

          <div className="form-group">
            <label>Judge Name</label>
            <input
              type="text"
              name="judge_name"
              value={formData.judge_name}
              onChange={handleInputChange}
              placeholder="Enter judge name"
            />
          </div>
        </div>

        {/* Client Details Section */}
        <div className="form-section">
          <h3>Client Details</h3>

          <div className="form-group">
            <label>Name *</label>
            <input
              type="text"
              name="client_name"
              value={formData.client_name}
              onChange={handleInputChange}
              placeholder="Enter client name"
              required
            />
          </div>

          <div className="form-group">
            <label>Phone Number</label>
            <input
              type="tel"
              name="client_phone"
              value={formData.client_phone}
              onChange={handleInputChange}
              placeholder="Enter client phone number"
            />
          </div>

          <div className="form-group">
            <label>Payment Amount</label>
            <input
              type="number"
              name="client_payment_amount"
              value={formData.client_payment_amount}
              onChange={handleInputChange}
              placeholder="Enter payment amount"
              min="0"
              step="0.01"
            />
          </div>
        </div>

        {/* Submit Button */}
        <button 
          type="submit" 
          className="submit-button"
          disabled={loading}
        >
          {loading ? 'Adding Case...' : 'Add Case'}
        </button>
      </form>
    </div>
  );
};

export default NewCase;
